export default {
  nav: {
    login: '登录',
    logout: '退出',
    person: '用户中心',
    message: '消息',
    my: '我的',
    request: '领用',
    applicant: '申购',
    purchaseReq: '申购',
    purchase: '采购',
    projects: '项目',
    favorite: '收藏',
    approve: '审批',
    requestApprove: '领用审批',
    applicantApprove: '申购审批',
    borrow: '借用信息',
    myBorrow: '我的借用',
    post: '发布借用',
    statistic: '统计信息',
    requestStatistic: '领用统计',
    approveStatistic: '审批统计',
    waste: '废弃物登记',
    search: '请输入物料名称，CAS号，物料编号，货号，规格型号等一键检索库存信息',
    structSearch: '结构式搜索',
    cart: '领用单',
    location: '当前位置',
    home: '首页',
    myFavorite: '我的收藏',
    myMessage: '我的消息',
    materielList: '物料列表',
    claimHistory: '我的领用',
    myApply: '我的申购',
    materialBorrow: '物料借用',
    notification: '通知消息',
    noAuth: '无权限',
    myProcurement: '我的采购',
    requestDetails: '领用详情',
    requestSuccess: '领用成功',
    wasteCollection: '废液收集',
    wasteRegister: '废弃物登记',
    wasteAdd: '废弃新增',
    wasteEdit: '废弃编辑',
    edit: '编辑',
  },
  page: {
    yuan: '元',
    fileReg: '文件格式错误',
    fileTypes: '文件格式不正确，请上传 {0}。',
    maxFileSize: '文件不能大于{0}',
    consumeQuantity: '使用量',
    manned: '有人值守',
    unmanned: '无人值守',
    outStock: '整瓶领用',
    subOutStock: '分装领用',
    childStructSearch: '子结构搜索',
    exactSearch: '精确搜索',
    similarSearch: '相似搜索',
    copyright: '版权所有：© {0} 苏州创腾软件有限公司  ',
    date: '日期',
    noAuth: '提醒',
    splitStockTip: '部分物料预计用量与领用量相等，将转为整瓶出库',
    expiryDate: '效期',
    overExpiryTime: '过效期',
    withExpiryTime: '近效期',
    inExpiryTime: '效期内',
    purchaseOrder: '采购单',
    exportPurchaseFileName: '采购单',
    screenLock: '屏幕锁定',
    psd: '密码',
    more: '更多',
    all: '全部',
    read: '已读',
    unread: '未读',
    notice: '通知公告',
    noticeDetail: '公告详情',
    notice1: '通知',
    notice2: '公告',
    myBorrow: '我借到的',
    mylend: '我借出的',
    taBorrow: 'TA的借用',
    approveCount: '审批数量',
    approveMoney: '审批金额',
    materiel: '物料',
    warehouse: '仓库',
    warehouseName: '仓库名称',
    supplier: '供应商',
    sAndp: '供应商/生产商',
    close: '收起',
    open: '展开',
    reagent: '化学试剂',
    materielNumber: '物料编号',
    molecularFormula: '分子式',
    molecularWeight: '分子量',
    accurateMass: '精确质量',
    appearance: '外观特征',
    stereoisomerDescription: '立体异构体描述',
    alias: '别名',
    requesthistory: '领用历史',
    approvehistory: '审批历史',
    thisReagent: '该试剂为',
    noteUse: '，请注意使用。',
    yes: '是',
    no: '否',
    cartToolTip: '剩余时间结束后，系统将自动回收物料，请尽快提交领用单!',
    cartSelectInfo: '（已选 {0} 个，共 {1} 个） 其他操作',
    continueRequest: '继续领用',
    deleteSelected: '删除所选',
    emptyAll: '清空领用单',
    noMaterielFind: '没有找到可以领用的物料',
    load: '数据加载完成',
    loadMore: '加载更多',
    noFavorite: '暂无收藏信息',
    requisition: '申购单',
    addRequisition: '填写申购单',
    inventoryQuantity: '库存量',
    inventoryInfo: '库存信息',
    materielInfo: '物料信息',
    noInventoryInfo: '未找到库存信息',
    lend: '借用',
    compound: '化合物',
    chartType: '图表类型',
    lineChart: '折线图',
    histogram: '柱状图',
    statisticTime: '统计时间',
    report: '报表',
    data: '数据',
    requestData: '领用数据',
    returnData: '退库数据',
    scrappData: '报废数据',
    yourMateriel: '您好，您领用的物料（',
    in: '）于',
    beginDelivery: '开始配送,请准备接收',
    baseInfo: '基本信息',
    applicantInfo: '申购信息',
    purchasing: '采购中的物料',
    approveYes: '审批完成',
    approveNo: '审批拒绝',
    materialDetail: '物料详情',
    materialInfo: '物料信息',
    chemProperty: '理化性质',
    density: '密度',
    meltlingPoint: '熔点',
    boilingPoint: '沸点',
    flashPoint: '闪点',
    refractiveIndex: '折射率',
    vapourPressure: '蒸气压',
    stability: '稳定性',
    sAndr: '存储及风险',
    incompatibilityInfo: '配存禁忌类型',
    storageCondition: '存储温度条件',
    Toxic: '剧毒',
    Pretoxic: '易制毒',
    Dangerous: '危险品',
    explosive: '易爆品',
    gb: '风险分类(国标)',
    gb1: '爆炸物',
    gb2: '腐蚀性',
    gb3: '高压气体',
    gb4: '环境危害',
    gb5: '健康危害',
    gb6: '氧化物',
    gb7: '易燃物',
    gb8: '有毒物质',
    gb9: '有害',
    om: '风险分类(欧盟)',
    om1: '风险说明',
    om2: '危险说明',
    om3: '安全说明',
    om4: '防范说明',
    om5: '存储说明',
    not: '无',
    toxicityInfo: '毒性信息',
    customNumber: '自定义编号',
    OHS1: 'OHS编号',
    OHS2: 'OHS名称',
    other: '其它',
    requestInfo: '领用信息',
    lifeCycle: '生命周期',
    library: '库中',
    putIn: '入库',
    approveFlow1: '等待审批',
    approveFlow2: '审批拒绝',
    approveFlow3: '等待拣货',
    approveFlow4: '等待出库',
    approveFlow5: '等待自取',
    approveFlow6: '等待配送',
    approveFlow7: '库管员驳回',
    requestMateriel: '领用物料',
    success1_1: '领用提交成功，请关注后续流程，耐心等待！',
    success1_2: '恭喜您，物料领用请求已被顺利提交，请继续关注后续处理流程！',
    success2: '其他操作',
    success3: '查看历史',
    success4: '温馨提示',
    success5_1: '领用后续流程：（有人值守）等待审批-库房处理流程图',
    success5_2:
      '领用后续流程：（无人值守）默认物料直接出库，领用状态变更为已签收，如果该物料类型在此仓库中被配置为无需退库，则物料状态及领用状态均直接变更为已报废。如果修改了仓库的默认审批流程，领用状态变更为待审批，审批通过后再按默认流程执行。',
    author: '作者',
    requestState1: '已提交待审批',
    requestState19: '待拣货',
    requestState200: '拣货中',
    requestState201: '已拣货待出库',
    requestState210: '拣货失败',
    requestState300: '已出库待自取',
    requestState301: '已出库待配送',
    requestState400: '配送中',
    requestState500: '已签收',
    searchInfo0: '库中未找到匹配的物料信息',
    searchInfo1: '，是否在',
    searchInfo2: '或者您可以',
    searchInfo3: '历史记录中未找到匹配的物料信息，是否需要提交申购',
    searchInfo4: '历史领用中查找',
    applyNow: '马上申购',
    neotrident: '苏州创腾软件有限公司',
    mimp: '物料信息管理平台',
    pageTitle: 'iLabPower CIMS 物料领用',
    exportAll: '导出全部记录',
    exportSelect: '导出选中记录',
    countAndmoney: '数量·金额',
    Narcotic: '麻醉类',
    Psychotropic: '精神类',
    Radioactive: '放射性',
    Explosives: '易制爆',
    attachment: '附件',
    requestable: '可领用',
    requested: '已领用',
    toTop: '回顶部',
  },
  message: {
    placeholder: '请输入{0}',
    placeSelect: '请选择{0}',
    miniPlaceSelect: '请选择',
    overZero: '{0}必须大于0',
    overAndZero: '{0}必须大于等于0',
    notNull: '{0}不能为空',
    notOver: '{0}的长度不能超过{1}个字',
    notOver1: '{0}的整数位长度不能超过{1}个字',
    notOver2: '{0}的小数位长度不能超过{1}个字',
    onlyOne: '能且只能选择一条物料',
    deleteTip: '您确认删除这条内容吗？',
    bottleTypeNoComplete: '包装规格未填写完整',
    noMateriel: '基础库无此化合物，请手工输入名称',
    materielIsExisted: '此试剂已经存在物料表中',
    casIsError: 'CAS号格式不正确',
    applicantSuccess: '申购保存成功',
    paramsError: '参数错误',
    noAuth: '无权限访问',
    index: '第{0}行的{1}',
    incomplete: '{0}未填写完整',
    isInteger: '{0}必须是正整数',
    notMore: '{0}不能大于{1}',
    mustMore: '{0}必须大于{1}',
    mustLess: '{0}必须小于{1}',
    decimal: '{0}最多{1}位小数',
    betweenorSame: '{0}必须大于等于{1}且小于等于{2}',
    mustNum: '{0}必须是数字',
    arrivalNumberOverLimit: '到货数量应不大于未到货数量',
    greaterOrEqual: '{0}必须大于等于{1}',
    lessOrEqual: '{0}必须小于等于{1}',
  },
  btn: {
    reLogin: '重新登录',
    defaultConfirm: '确认',
    search: '搜索',
    add: '新建',
    remove: '删除',
    edit: '编辑',
    submit: '提交',
    submiting: '提交中',
    submitSucc: '提交成功',
    saving: '保存中',
    saved: '保存',
    saveDraft: '保存草稿',
    saveAndSubmit: '保存并提交',
    success: '成功',
    cancel: '取消',
    preview: '预览',
    submitRequest: '提交领用',
    _btnSubmit: '提交领用',
    return: '退库',
    scrapp: '报废',
    store: '存放',
    approveDetail: '审批详情',
    batchReturn: '批量退库',
    batchScrapp: '批量报废',
    batchStore: '批量存放',
    yes: '同意',
    no: '拒绝',
    batchYes: '批量同意',
    batchNo: '批量拒绝',
    batchReceive: '批量接收',
    batchReceived: '批量收货',
    selectAll: '全选',
    cancelAll: '取消全选',
    doing: '处理中',
    applicant: '申购',
    batchSubmit: '批量提交',
    batchDelete: '批量删除',
    batchWithdrawal: '批量撤回',
    completelyNew: '完全新建',
    addFrom: '从已有物料新建',
    completelyApplicant: '全新申购',
    exporting: '导出',
    receiving: '接受中',
    exportPurchase: '导出采购单',
    purProcess: '采购处理',
    settlementting: '结算中',
    settlement: '结算',
    enable: '可用',
    disable: '禁用',
    confirm: '确认完成',
    confirmReceive: '确认收到',
    confirmLend: '确认借出物料',
    choose: '选择',
    posting: '发布中',
    post: '发布借用',
    viewHistory: '查看领用记录',
    lendNow: '立即借出',
    batchRead: '批量已读',
    allMsg: '全部消息',
    approveMsg: '审批消息',
    deliveryMsg: '配送消息',
    borrowMsg: '借用消息',
    applicantMsg: '申购消息',
    viewMsgDetail: '点击查看详情',
    domestic: '国产',
    import: '进口',
    internal: '内部合成',
    purchaseInfo: '采购信息',
    massReject: '批量退回',
    massReason: '退回理由',
    massReason1: '退回原因',
    massReasonPlaceholder: '请输入退回理由，字符限制1000字',
    finishPurchase: '结束采购',
    finishReason: '结束理由',
  },
  action: {
    add: '新建{0}',
    edit: '编辑{0}',
    remove: '删除{0}',
  },

  form: {
    useFor: '用途',
    processMode: '处理方式',
    returnReason: '退库原因',
    scrappedReason: '报废原因',
    stroeLoc: '存储位置',
    withdraw: '撤回',
    withdrawReason: '撤回原因',
    try: '没找到？试试',
    notFind: '未找到匹配的物料信息！是否',
    approvalIdea: '审批意见',
    perfectPurInfo: '更新采购信息',
    fillReceiptInfo: '填写收货信息',
    projectName: '项目编号（名称）',
    projectCode: '项目编号',
    projectLeader: '项目负责人',
    filter: '支持输入检索匹配',
    projectMember: '项目成员',
    projectDesc: '项目描述',
    projectDeleteTip1: '您确定要删除 ',
    projectDeleteTip2: ' 吗？',
    noDept: '当前用户未分配部门',
    chooseMateriel: '选择物料',
    deadline: '截止日期',
    note: '备注',
    chinName: '中文名称',
    chinAlias: '中文别名',
    chemName: '英文名称',
    chemAlias: '英文别名',
    wasteTitle: '实验室废弃物料收集记录表',
    waste1: '废弃物料类别/名称',
    waste2: '类别',
    waste3: '名称',
    waste4: '成分',
    waste5: '产生、收集者信息',
    waste6: '单位名称',
    waste7: '实验室名称',
    waste8: '收集者',
    waste9: '地址/位置',
    waste10: '联系电话',
    waste11: '包装/容器',
    waste12: '容器编号',
    waste13: '编号',
    waste14: '颜色',
    waste15: '贮存地点',
    waste16: '区域',
    waste17: '地址/位置',
    waste18: '废弃物料来源',
    waste19: '来源',
    waste20: '由什么试验、检测项目产生，含有什么成分',
    waste21: '废弃物料物理状态',
    waste22: '危险性类别',
    waste23: '存储时间',
    waste24: '混合收集时间表',
    waste25: '初次存储时',
    waste26: '混合收集时间表(附每次数量)：可另附',
    waste27: '数量（合计）',
    waste28: '其他说明资料',
    waste29: '移交处理部门时间',
    waste30: '备注',
    waste31: '负责人/管理员签字',
  },
  columns: {
    controlType: '管控类型',
    requestCode: '领用单号',
    receptionNo: '领用单号',
    purchaseCode: '申购单号',
    poNumber: '采购单号',
    bottleName: '物料名称',
    materialName: '物料名称',
    categoryCode: '物料类别',
    categoryName: '物料类别',
    CASNumber: 'CAS号',
    purity: '纯度',
    purity1: '规格型号',
    requestQuantity: '领用量',
    quantity: '数量',
    estimatedAmount: '预计用量',
    projectCode: '所属项目',
    requestDate: '领用时间',
    applyDate: '领用时间',
    applicantDate: '申购时间',
    approveUsersNames: '审批人',
    approveUser: '审批人',
    approveReason: '拒绝原因',
    requestState: '领用状态',
    requester: '领用人',
    requisitionNo: '领用单号',
    price: '单价',
    number: '数量',
    totalPrice: '总价',
    applicant: '申购人',
    applyTime: '提交时间',
    submitTime: '领用时间',
    _submitTime: '提交时间',
    procurementScheduleStatus: '采购状态',
    barcode: '条码',
    barcode1: '物料条码',
    bottleType: '包装规格',
    bOrp: '规格型号/纯度',
    currentQuantity: '当前量',
    currentAmount: '当前量',
    sublocation: '库位',
    catalogNumber: '货号',
    lotNumber: '批号',
    itemState: '状态',
    phone: '手机号',
    delivery: '配送',
    remainTime: '剩余时间',
    operation: '操作',
    noDataText: '加载中...',
    noDataText2: '暂无数据',
    state: '状态',
    deliverer: '配送人',
    receiveDate: '签收时间',
    completeTime: '退库时间',
    createTime: '创建时间',
    bfTime: '报废时间',
    applicantTime: '申购时间',
    estimatedArrival: '预计到货时间',
    approveState: '审批状态',
    expectationPeriod: '期望供货期',
    estimatedArrivalTime: '预计到货期',
    approveTime: '审批时间',
    producer: '生产商',
    producer1: '生产者',
    expiryDate: '有效期至',
    expireTime: '有效期',
    origin: '来源',
    myProject: '我的项目',
    desc: '描述',
    user: '用户',
    demand: '需求量',
    postTime: '发布时间',
    _postTime: '发布时间',
    detail: '详情',
    lendTo: '借给谁',
    lendMateriel: '借出物料',
    LendCount: '借出量',
    lentTime: '借出时间',
    mdl: 'MDL号',
    requestHistory: '领用记录',
    lab: '实验室',
    lnedTa: '借给他',
    lnedMateriel: '借用物料',
    publisher: '发布人',
    initialQuantity: '入库净量',
    comment: '说明',
    unitPrice: '价格',
    pruchasePrice: '单位价格',
    chemicalName: '废弃物名称',
    chemicalType: '废弃物类别',
    companyName: '单位名称',
    numbering: '编号',
    requestUnit: '单位',
    title: '标题',
    type: '类型',
    effectiveDate: '有效日期',
    settle: '已结算',
    notSettle: '未结算',
    note: '备注',
    grossWeight: '毛重',
    restGoods: '剩余到货数',
    arrivalQuantity: '到货数量',
    undeliveredQuantity: '未到货数量',
    dangerous: '危险类型',
  },
  unit: {
    bottle: '瓶',
    l: '升',
    ml: '毫升',
    g: '克',
    kg: '千克',
  },
  time: {
    time: '时间',
    day: '天',
    month: '月',
    hour: '小时',
    zero: ' 零 ',
    expireDate: '领用超时，已失效',
  },
  dic: {},
  tour: {
    buttonSkip: '跳过引导页',
    buttonPrevious: '上一步',
    buttonNext: '下一步',
    buttonStop: '完成',
    content1: '输入物料名称，CAS号等条件，以空格隔开，搜索物料',
    content2: '在用户中心可以进行物料的借用和审批哦',
    content3: '点击这里查看你发布的借用信息',
    content4: '别人也发布了借用，你看看能否帮助到ta',
    content5: '别人也发布了借用，你看看能否帮助到ta',
  },
  tab: {
    approving: '待审批',
    approvTo: '审批中',
    approved: '已通过',
    receipting: '待签收',
    rejected: '已拒绝',
    signed: '已签收',
    dispenssed: '已分装',
    returned: '已退库',
    scrapped: '已报废',
    pending: '待提交',
    processing: '待处理',
    processed: '已处理',
    settle: '已结算',
    placed: '已下单',
    receiving: '待接收',
    received: '已接收',
    receipt: '待收货',
    arrived: '已到货',
    myBorrow: '我借到的',
    myLend: '我借出的',
    dispensed: '被领用',
    shelvedMsg: '上架消息',
    returnBack: '已退回',
    pruchaseReturnBack: '采购退回',
    applicantRejected: '申购拒绝',
    ended: '已结束',
  },
  key1: '库管员驳回，驳回原因：',
  key2: '已驳回',
  key3: '填写退库信息',
  key4: '实际用量',
  key5: '退回人',
  key6: '退回时间',
  key7: '退回原因',
  key8: '申购备注',
  key9: '生产商',
  key10: '货号',
  key11: '采购备注',
  key12: '出库异常',
  key13: '确认结算信息',
  key14: '库别',
  key15: '预算总额',
  key16: '累计支出',
  key17: '剩余额度',
  key18: '确认同意',
  key19: '确认拒绝',
  key20: '审批结果',
  key21: '储存条件',
  key22: '此项目是CIMS本地项目',
  key23: '全部领用',
  key24: '自光标处开始，从上向下填充',
  key25: '审批信息',
  key26: '您已将{0}条物料加入领用单',
  key27: '没有可以领用的物料',
  key28: '剩余量',
  key29: '再次领用',
  key30: '点击查看CMS结构式',
  key31: '高级搜索',
  key32: '重置条件',
  key33: '修改采购单',
  key34: '使用人',
  key35: '使用项目',
  key36: '实验编号',
  key37: '使用时间',
  key38: '使用记录',
  key39: '新增',
  key40: '操作人',
  key41: '操作时间',
  key42: '操作类型',
  key43: '操作前值',
  key44: '操作后值',
  key45: '使用记录的使用量总和将超过物料的当前量，确定添加？',
  key46: '修改原因',
  key47: '使用量超出原因',
  key48: `条码为{0}的{1}使用量修改为{2}`,
  key49: '已超过物料的当前量，无法对物料进行退库，请重新修改使用量或改为提交报废申请',
  key50: '自取签收',
  key51: '自取人',
  key52: '自取时间',
  key53: '结构搜索',
  key54: '高级搜索',
  key55: '添加使用记录',
  key56: '查看使用记录',
  key57: '查看日志',
  key58: `使用量合计：{0}； 领用量：{1}； 剩余可用量：{2}`,
  key59: '使用量之和已等于或超过领用时的领用量，无法继续录入使用记录',
  key60: '{0}将使用量从{1}修改为{2}，修改原因：{3}',
  key61: '修改原因：{0}',
  key62: '使用量超出原因：{0}',
  key63: '，',
  key64: '当前领用单尚未有使用记录',
  key65: '当前领用单尚无使用记录的修改日志',
  key66: '扫码加领用单',
  key67: '扫码加入领用单',
  key68: '添加',
  key69: '指派记录',
  key70: '接收人',
  key71: '加入领用单',
  key72: '分瓶领用',
  key73: '确定',
  key74: '已预订分瓶量',
  key75: '剩余可分瓶量',
  key76: '分瓶量',
  key77: '已预订分瓶量',
  key78: '预定分瓶信息',
  key79: '{0}（{1}）的分瓶预定信息',
  key80: '分瓶单号',
  key81: '分瓶领用人',
  key82: '分瓶量',
  key83: '分瓶记录',
  key84: '申请分瓶量',
  key85: '实际分瓶量',
  key86: '申请时间',
  key87: '重新提交',
  key88: '查看领用信息',
  key89: '您确认要撤回这条分瓶记录吗？',
  key90: '修改分瓶领用信息',
  key91: '请输入您要分瓶领用的库存量',
  key92: '分瓶领用审批',
  key93: '子瓶条码',
  key94: '提交审批',
  key95: '审批流',
  key96: '步骤',
  key97: '请选择审批人',
  key98: '至少选择一位审批人',
  key99: '仓库信息缺失',
  key100: '选择共同操作人',
  key101: '共同操作人',
  key102: '密码',
  key103: '请选择共同操作人',
  key104: '请输入密码',
  key105: '暂无可选的共同操作人',
  key106: '双人双锁',
  key107: '选中的数据只能包含一个双人双锁的仓库！',
  _key66: '批量导入',
  _key67: '点击下载导入模板',
  _key68: '选择文件',
  _key69: '导入结果',
  _key70: '行号',
  _key71: '查看更多',
  _key72: '导入结果',
  _key73: '请先上传文件',
  _key74: '导入成功',
  _key75: '导入失败',
};
